import { useState, useContext } from 'react';

import { message } from 'antd';
import callContext from '@/pages/crm/callCenter/callManage/callManageContext'
import { size } from 'lodash-es';

import {SLowcodeList, STriggerModal} from 'shj-components';
import {callAppointDispatch, queryEmployeePage} from "@/services/callCenter";
import {apiData2Table} from "@/utils/data.ts";

function MarketingModal(props: any) {
  const { callManageState } = useContext(callContext)
  const {
    callDetails
  } = callManageState
  const columns = [
    {
      title: '员工姓名',
      dataIndex: 'userName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '员工工号',
      dataIndex: 'loginAccount',
      width: 150,
    },
    {
      title: '所属组织',
      dataIndex: 'orgNamePath',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '职位',
      dataIndex: 'roleName',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
    },
  ];
  const { open, onCancel, fn, buttonKey } = props;

  const [selectedRowKey, setSelectedRowKey] = useState<any>([]);
  const [selectedRows, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      queryEmployeePage({
        params: {
          pageId: current,
          pageSize
        },
        data: {...query, clueId: callDetails.id, trackPlanNodeId: callDetails.currentNodeId, button: buttonKey},
      }).then(res => {
        resolve(apiData2Table(res))
      }).catch(() => reject())
    })
  };

  const onFinish = () => {
    console.log(selectedRows, loading, 1111)
    if (loading) return
    if (!size(selectedRows)) {
      message.warning('请选择人员');
      return
    }
    setLoading(true)
    const relatives = {}
    relatives.deptId = selectedRows.orgId;
    relatives.roleCode = selectedRows.roleCode;
    relatives.companyId = selectedRows.companyId;
    relatives.name = selectedRows.userName;
    relatives.ucenterUserId = selectedRows.ucenterUserId;
    callAppointDispatch({clueId: callDetails.id, buttonKey: props.buttonkey, relatives})
      .then((res) => {
        message.success(res.message || '操作成功');
        setSelectedRowKey('');
        setSelectedRow({});
        onCancel()
        fn && fn()
      }).finally(() => { setLoading(false)})
  };

  const extensions = {
    request: {fetchList},
    rowSelection: {
      type: 'radio',
      selectedRowKeys: selectedRowKey,
      onChange: (selectedRowKeys: any, selectedRows: any) => {
        if (selectedRows.length) {
          setSelectedRowKey(selectedRowKeys);
          setSelectedRow({ ...selectedRows[0] });
      }
     },
    }
  }

  return (
    <STriggerModal
      // onReset={onReset}
      width="900px"
      title={'指定派单'}
      onFinish={onFinish}
      open={open}
      onCancel={onCancel}
      confirmLoading={loading}
      destroyOnClose={true}
    >
      <SLowcodeList searchMode={'group'} config={{
        scroll: {y: 350},
        fieldControl: false,
        columns,
        search: [{name: 'userNameKeyword', label: '姓名'}]
      }} {...extensions}/>
    </STriggerModal>
  );
}

export default MarketingModal;
